<template>
  <b-modal
    v-model="show"
    title="Atribuir fichas"
    size="md"
    @hidden="onClose"
    :no-close-on-backdrop="true"
  >
    <div v-if="loading" class="text-center">
      <b-spinner></b-spinner>
      <p>Carregando operadores...</p>
    </div>

    <div v-else>
      <p class="mb-3">A qual operador deseja atribuir as fichas?</p>

      <!-- LISTA DE OPERADORES -->
      <div class="operator-list">
        <div
          v-for="operator in operators"
          :key="operator.id"
          class="operator-item p-3 mb-2 border rounded cursor-pointer"
          :class="{'selected': selectedOperator === operator.id}"
          @click="selectOperator(operator.id)"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="mb-0">{{ operator.name }}</h6>
              <small class="text-muted">Fichas atribuídas: {{ operator.assigned_count || 0 }}</small>
            </div>
            <div v-if="selectedOperator === operator.id">
              <i class="mdi mdi-check-circle text-primary" style="font-size: 24px;"></i>
            </div>
          </div>
        </div>
      </div>

      <div v-if="operators.length === 0" class="alert alert-warning">
        Nenhum operador disponível
      </div>

      <!-- RESUMO -->
      <div v-if="selectedOperator" class="alert alert-info mt-3">
        <strong>{{ selectedParticipants.length }} fichas</strong> serão atribuídas a
        <strong>{{ selectedOperatorName }}</strong>
      </div>
    </div>

    <template #modal-footer>
      <button class="btn btn-secondary" @click="onClose">Cancelar</button>
      <button
        class="btn btn-primary"
        @click="assign"
        :disabled="!selectedOperator || assigning"
      >
        <span v-if="assigning">
          <b-spinner small></b-spinner> Atribuindo...
        </span>
        <span v-else>
          <i class="mdi mdi-check"></i> Atribuir
        </span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import services from '../services'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  name: 'ModalAssignManual',
  props: {
    value: Boolean,
    selectedParticipants: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      assigning: false,
      operators: [],
      selectedOperator: null
    }
  },
  computed: {
    selectedOperatorName () {
      const operator = this.operators.find(o => o.id === this.selectedOperator)
      return operator ? operator.name : ''
    }
  },
  watch: {
    value (val) {
      this.show = val
      if (val) {
        this.loadOperators()
      }
    },
    show (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    async loadOperators () {
      this.loading = true
      try {
        const res = await services.getOperators()
        this.operators = res.data.data || []
      } catch (error) {
        errorMessage('Erro ao carregar operadores')
      } finally {
        this.loading = false
      }
    },

    selectOperator (id) {
      this.selectedOperator = id
    },

    async assign () {
      if (!this.selectedOperator) {
        errorMessage('Selecione um operador')
        return
      }

      this.assigning = true
      try {
        const promises = this.selectedParticipants.map(participantId => {
          return services.assignParticipant({
            participant_id: participantId,
            admin_user_id: this.selectedOperator
          })
        })

        await Promise.all(promises)

        successMessage(`${this.selectedParticipants.length} fichas atribuídas com sucesso!`)
        this.$emit('assigned')
        this.onClose()
      } catch (error) {
        errorMessage(error.response?.data?.message || 'Erro ao atribuir fichas')
      } finally {
        this.assigning = false
      }
    },

    onClose () {
      this.show = false
      this.selectedOperator = null
    }
  }
}
</script>

<style scoped>
.operator-list {
  max-height: 400px;
  overflow-y: auto;
}

.operator-item {
  transition: all 0.2s;
  cursor: pointer;
}

.operator-item:hover {
  background-color: #f8f9fa;
  border-color: #0d6efd !important;
}

.operator-item.selected {
  background-color: #e7f3ff;
  border-color: #0d6efd !important;
  border-width: 2px !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
